import { AppBar, Toolbar, Box, InputBase, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { drawerWidth, collapsedDrawerWidth, primaryColor } from '../../utils/theme';

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  color: theme.palette.custom.sidebarText,
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
  height: '64px',
  minHeight: '64px',
  zIndex: theme.zIndex.drawer,
  width: '100%',
  marginLeft: 0,
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
}));

export const HeaderToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: '64px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingLeft: 0,
  paddingRight: theme.spacing(3),
}));

export const HeaderTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})<{ collapsed?: boolean }>(({ theme, collapsed }) => ({
  fontWeight: 600,
  fontSize: '1rem', // Reduced from 1.2rem
  color: theme.palette.custom.sidebarText,
  paddingLeft: theme.spacing(3),
  marginLeft: collapsed ? collapsedDrawerWidth : drawerWidth,
  transition: theme.transitions.create(['margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
}));

export const SearchAndNotificationContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.white.main,
  border: `1px solid ${theme.palette.grey[400]}`,
  width: '280px',

  '&:hover': {
    border: `1px solid ${theme.palette.grey[500]}`,
  },
  '&:focus-within': {
    border: `1px solid ${primaryColor}`,
  },
  height: '40px',
}));

export const SearchIconWrapper = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: 0,

  padding: theme.spacing(0, 1.5),
  height: '100%',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: primaryColor,
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  height: '100%',

  '& .MuiInputBase-input': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(6),
    width: '100%',
    '&::placeholder': {
      color: theme.palette.grey[400],
      opacity: 1,
    },
    color: theme.palette.custom.sidebarText,
  },
}));